<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            class="text-center"
          >
            <dashboard-porcentagem-mix-comercializado />
          </div>
          <div
            class="text-center"
          >
            <v-row v-if="exibirMix">
              <v-col
                cols="12"
                sm="8"
                md="8"
                lg="8"
              >
                {{ mixVendido }} <br>
                MIX Vendido
              </v-col>
            </v-row>
          </div>
          <div
            class="text-center"
          >
            <v-row v-if="exibirMix">
              <v-col
                cols="12"
                sm="8"
                md="8"
                lg="8"
              >
                {{ produtosAtivos }} <br>
                Produtos Ativos
              </v-col>
            </v-row>
          </div>
          <div
            class="text-center"
          >
            <dashboard-porcentagem-mix-comercializado-anual id="graficoMixComercializado" />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../../services/somentecliente'
  import eventEmit from '../../../core/EventoEmit'

  export default {
    name: 'ShowExtratoClientesFaturados',
    emits: ['setDadosMixComercializado', 'setDadosMixComercializadoPorcentagem'],
    components: {
      DashboardPorcentagemMixComercializado: () => import('../../../../graficos/SomenteClientes/ExtratoCliente/ClientesPorcentagemMixComercializado'),
      DashboardPorcentagemMixComercializadoAnual: () => import('../../../../graficos/SomenteClientes/ExtratoCliente/ClientesPorcentagemMixComercializadoAnual'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      selectCliente: JSON.parse(localStorage.clienteSelect),
      exibirMix: false,
      mixVendido: 0,
      produtosAtivos: 0,
      vendedores: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
    }),

    created () {
      eventEmit.$on('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, selectCliente, vendedores, area, rede, supervisor, receita, segmento, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.select = select
        this.selectCliente = selectCliente
        this.vendedores = vendedores
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.showDadosMixComercializado()
      },

      async showDadosMixComercializado () {
        this.loading = true
        this.exibirMix = false

        this.mixVendido = 0
        this.produtosAtivos = 0

        eventEmit.$emit('set-dados-mix-comercializado', 0, 100)
        eventEmit.$emit('set-dados-mix-comercializado-porcentagem', [], [])

        await Clientes.showClientesMixComercializado(this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, this.vendedores, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.mixVendido = resposta.data.produtoVendidos

            this.produtosAtivos = resposta.data.produtoAtivos

            eventEmit.$emit('set-dados-mix-comercializado', resposta.data.porcentagem, resposta.data.porcentagemRestante)
            eventEmit.$emit('set-dados-mix-comercializado-porcentagem', resposta.data.labels, resposta.data.porcentagemExibicao)
          } else if (resposta.data.msg === 'Não há dados semestral para a exibição') {
            this.mixVendido = 0

            this.produtosAtivos = 0

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data Final não pode ser mair que a data inicial') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirMix = true
        })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
